import React, { useEffect, useState } from 'react';
import * as SP from '@/main/components/shared/styles';
import * as S from './styles';
import { getTranslateByKey } from '@/main/services/utils';
import SecondaryButton from '../../button/secondaryButton';
import KOGPaginationGrid from '../../paginationGrid/paginationGrid';
import BoxGrid from '../../boxGrid/boxGrid';
import { supervisionAssignmentApi } from '@/main/api/supervisionAssignmentApi';

import RowSupervisorAssignment from '../rowSupervisorAssignment/rowSupervisorAssignment';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import SupervisorBodyshopSidebar from '../SupervisorBodyshopSidebar/SupervisorBodyshopSidebar';
import { SupervisionAssignmentPaginedRequest } from '@/main/models/request/supervisionAssignment';
import { SupervisorAssignmentResponse } from '@/main/models/response/supervisionAssignmentResponse';

interface ISupervisorBodyShopGridProps {
  guidCompany: string;
}

function SupervisorBodyShopGrid ({
    guidCompany
} : ISupervisorBodyShopGridProps){
    //#region states
    const [
        formFilters,
        setFormFilters
      ] = useState<SupervisionAssignmentPaginedRequest | null>(null);

    const [dataGrid, setDataGrid] = useState<SupervisorAssignmentResponse[]>(
        []
      );

    const [modalOpen, setModalOpen] = useState<boolean>(false);
    //#endregion

    //#region functions
    async function fetchData(request: any) {
        return supervisionAssignmentApi
        .getBodyShopByCompany(request)
        .then(response => 
            response.data,
        );
    }

    function resetFilters() {
        const request: SupervisionAssignmentPaginedRequest = {
          guidCompany: guidCompany,
          pageIndex: PaginationEnum.PageIndexIntial,
          pageSize: PaginationEnum.PageSize10
        };
    
        setDataGrid([]);
        setFormFilters(request);
      }
    //#endregion

    useEffect(() => {
    const initialRequest: SupervisionAssignmentPaginedRequest = {
        guidCompany: guidCompany,
        pageIndex: PaginationEnum.PageIndexIntial,
        pageSize: PaginationEnum.PageSize10
    };

    setFormFilters(initialRequest);
    }, [guidCompany]);


    //#region render constants
    const ID_SCROLLABLE_TARGET =
        'id-scrollable-myBodyshops-container';

    const rowHeaders = [
        getTranslateByKey('information.rfc'),
        getTranslateByKey('companyType.bodyshop'),
        getTranslateByKey('information.dateTimeUser'),
        getTranslateByKey('information.insurer'),
        getTranslateByKey('information.actions')
        ];
    //#endregion

    //#region handles
    function handleShowModal(){
        if(!modalOpen)
            setModalOpen(true);
    }

    async function CloseModal(reset: boolean = false){
        setModalOpen(false);
        if(reset) resetFilters();

    }
    //#endregion

    return(
        <S.Container>
            <S.ContainerSection>
                <S.RowSelect>
                    <S.HeaderSection>
                        <SP.HeaderText>
                            {getTranslateByKey('information.myBodyshops')}
                        </SP.HeaderText>

                        <SecondaryButton
                            style={{
                                padding: '0.2rem 0.8rem',
                                marginLeft: '1rem' 
                            }}
                            onClick={handleShowModal}
                            id="id-registerInsurer-btn-addMyBodyshops">
                            {getTranslateByKey('information.addMyBodyshops')}
                        </SecondaryButton>
                    </S.HeaderSection>
                </S.RowSelect>

                <S.ContainerPagination id={ID_SCROLLABLE_TARGET}>
                    <KOGPaginationGrid
                        showResultNotFound={false}
                        fetchEqualFilters={true}
                        idScrollableTarget={ID_SCROLLABLE_TARGET}
                        dataGrid={dataGrid}
                        formFilters={formFilters}
                        setDataGrid={setDataGrid}
                        fetchMore={fetchData}>
                        <BoxGrid rowHeaders={rowHeaders}>
                            {dataGrid.map((assignment ) => (
                            <RowSupervisorAssignment 
                                key={assignment.guid}
                                assignment={assignment}
                                resetFilters={resetFilters} />
                            ))}
                        </BoxGrid>
                    </KOGPaginationGrid>
                </S.ContainerPagination>
                <SupervisorBodyshopSidebar 
                    guidCompany={guidCompany}
                    open={modalOpen}
                    closeModal={CloseModal}
                    />
            </S.ContainerSection>
        </S.Container>
    )
}

export default SupervisorBodyShopGrid;